<!-- WORK IN PROGRESS -->
<script>
  import Link from "$lib/components/Link.svelte";
  import Icon from "$lib/components/Icon.svelte";
  import ExpandableIcon from "./ExpandableIcon.svelte";

  export let data;
  export let isOpen;
</script>

<div class="text-left">
  {#if data.fields.trigger?.fields?.type === "hamburger"}
    <Link class="!no-underline" on:click haspopup expanded={isOpen}>
      {#if isOpen}
        <Icon type="close" />
      {:else}
        <Icon type="menu" />
      {/if}
    </Link>
  {:else if data.fields.trigger?.fields?.type === "carat"}
    <Link
      class="!text-black !no-underline lg:!px-16 sm:!px-32 sm:!py-8"
      on:click
      haspopup
      expanded={isOpen}
    >
      <div class="flex">
        <span class="pr-8">{data.fields.trigger?.fields?.text}</span>
        <ExpandableIcon {isOpen} />
      </div>
    </Link>
  {:else}
    <Link class="!text-black !no-underline !py-8 !px-0" on:click>
      {data.fields.headerText || data.fields.text || data.fields.name}
    </Link>
  {/if}
</div>
